// @ts-nocheck -- Gadget Client types are stale; will resolve after ggt push regenerates types
/**
 * File: web/routes/_auth.tsx
 * Purpose: Unified auth layout (sign-in, sign-up, magic-link verify).
 * Visual treatment: warm amber gradient backdrop with centered card,
 * brand wordmark above the card, legal links footer below.
 * Mirrors the shared KH auth layout used across Benchmark, LeisureHub,
 * Manos and FreeTime -- only the brand color/wordmark differ per app.
 */

import { Link, Outlet, redirect, useOutletContext } from "react-router";
import type { RootOutletContext } from "../root";
import type { Route } from "./+types/_auth";

const COPYRIGHT_YEAR = 2026;

export const loader = async ({ context }: Route.LoaderArgs) => {
  const { session, gadgetConfig } = context;

  const signedIn = !!session?.get("user");

  if (signedIn) {
    return redirect(gadgetConfig.authentication!.redirectOnSuccessfulSignInPath!);
  }

  return {};
};

export default function AuthLayout() {
  const context = useOutletContext<RootOutletContext>();

  return (
    <div className="relative min-h-screen flex flex-col items-center justify-center p-4 sm:p-6 overflow-hidden bg-gradient-to-br from-amber-700 via-amber-500 to-orange-400">
      {/* Wordmark */}
      <div className="relative z-10 mb-8">
        <Link to="/" className="inline-flex hover:opacity-90 transition-opacity">
          <span className="text-3xl font-extrabold tracking-tight text-white">
            Manos
          </span>
        </Link>
      </div>

      {/* Card slot -- MagicLinkAuth renders the card itself */}
      <main className="relative z-10 w-full max-w-md">
        <Outlet context={context} />
      </main>

      {/* Footer */}
      <footer className="relative z-10 mt-8 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm text-white/80">
        <span>&copy; {COPYRIGHT_YEAR} Manos</span>
        <span aria-hidden="true">|</span>
        <Link to="/terms" className="hover:text-white transition-colors">
          Terms
        </Link>
        <Link to="/privacy" className="hover:text-white transition-colors">
          Privacy
        </Link>
        <Link to="/cookies" className="hover:text-white transition-colors">
          Cookies
        </Link>
      </footer>
    </div>
  );
}